import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon53: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 16.0

  const originalHeight = 20.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 16 20" width={width} height={height} {...props}>
      <Path
        d="M8.53802 0.0256108C11.358 0.293611 13.5 2.80461 13.5 5.71461V9.99061L13.991 9.99161C15.1 9.99161 16 10.8906 16 11.9996V16.0186C16 18.2126 14.221 19.9916 12.027 19.9916H3.97302C1.77902 19.9916 0 18.2126 0 16.0186V11.9996C0 10.8906 0.899972 9.99161 2.00897 9.99161L2.5 9.99061V5.49961C2.5 2.25961 5.28403 -0.284389 8.53802 0.0256108ZM13.991 10.9916L13.034 10.9926C13.023 10.9936 13.011 10.9936 13 10.9936L12.966 10.9906L11.034 10.9926C11.023 10.9936 11.011 10.9936 11 10.9936L10.966 10.9906L2.00897 10.9916C1.45197 10.9916 1 11.4426 1 11.9996V16.0186C1 17.6606 2.33102 18.9916 3.97302 18.9916H12.027C13.669 18.9916 15 17.6606 15 16.0186V11.9996C15 11.4426 14.548 10.9916 13.991 10.9916ZM8 12.9936C8.276 12.9936 8.5 13.2176 8.5 13.4936V16.4936C8.5 16.7696 8.276 16.9936 8 16.9936C7.724 16.9936 7.5 16.7696 7.5 16.4936V13.4936C7.5 13.2176 7.724 12.9936 8 12.9936ZM3.5 5.49961V9.99061H4.5V5.4936C4.5 3.5606 6.067 1.9936 8 1.9936C9.933 1.9936 11.5 3.5606 11.5 5.4936V9.99061H12.5V5.71461C12.5 3.30661 10.736 1.23961 8.44397 1.02061C5.77697 0.766606 3.5 2.84861 3.5 5.49961ZM8 2.9936C6.619 2.9936 5.5 4.1126 5.5 5.4936V9.99061H10.5V5.4936C10.5 4.1126 9.381 2.9936 8 2.9936Z"
        fill="#FFD147"
      />
    </Icon>
  )
}
